/**
 * Narrowing helpers for JSON-ish payloads that cross the wire
 * (run events, tool payloads, UI renderers). Kept in contracts so
 * the Next app, control plane, and worker use one canonical
 * implementation.
 */
export function readString(value) {
    return typeof value === "string" ? value : undefined;
}
export function readNumber(value) {
    return typeof value === "number" && Number.isFinite(value) ? value : undefined;
}
export function readObject(value) {
    return value && typeof value === "object" && !Array.isArray(value)
        ? value
        : undefined;
}
export function parsePayloadJson(payloadJson) {
    try {
        const parsed = JSON.parse(payloadJson);
        return readObject(parsed) ?? {};
    }
    catch {
        return {};
    }
}
